/**
 * `Re: ` unless it already is one.
 *
 * Mirrors the server's `subject_for_reply` (cynque-api-server
 * services/email_threading.py): only ONE prefix ever, matched case-insensitively
 * because clients disagree (`RE:`, `Re:`) and localise it, and a bare `Re:` when
 * there is no subject to prefix. Mail clients thread on References, not the
 * subject, so stacking `Re: Re:` is only noise a human has to read past.
 *
 * Shared by the case Send Email form (its Subject prefill) and the MSW mock
 * (the subject it records when none is sent), so the two cannot drift.
 */
export function subjectForReply(subject: string): string {
  const stripped = (subject ?? '').trim()
  if (stripped.toLowerCase().startsWith('re:')) {
    return stripped
  }
  return stripped ? `Re: ${stripped}` : 'Re:'
}
